/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_CoursesInputs */

const de__field_courses = /** @type {(inputs: _Field_CoursesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wöchentliches Prüfungstraining`)
};

/**

* @param {_Field_CoursesInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_courses = /** @type {((inputs?: _Field_CoursesInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_CoursesInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_courses(inputs)
});